import { Box, Button, Container, Heading, HStack, Link, Stack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import { FontFamily } from '@common/theming/Fonts';
import * as React from 'react';
import { Link as RRDLink } from 'react-router-dom';
import { TextBlock } from '../../common/components/TextBlock';
import { ROUTES } from '../../config';

export const SignOutPage = () => {
  return (
    <Container maxW="md">
      <Stack spacing="8">
        <Stack spacing="6" align={'center'} gap={5}>
          <Image image="logo" w={'300px'} mt={20} />
          <Box backgroundColor={'blue.50'} padding="10px" borderRadius={'50%'}>
            <Box backgroundColor={'blue.100'} padding="20px" borderRadius={'50%'}>
              <Icon icon="hand-wave" boxSize={'20px'} color="blue.500" />
            </Box>
          </Box>
          <Stack spacing={{ base: '2', md: '3' }} textAlign="center" gap={5}>
            <Heading fontWeight={'normal'} fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
              You've been signed out
            </Heading>
            <TextBlock color="muted">
              Whether you're a rookie getting into real estate or an investing veteran , we've got you covered. {` `}
              <Link href="https://www.concreit.com/learn" target={'_blank'}>
                Learn more about how to grow your money
              </Link>
            </TextBlock>
            <Button as={RRDLink} to={ROUTES.signin}>
              Sign In
            </Button>
          </Stack>
        </Stack>
        <HStack spacing="1" justify="center">
          <TextBlock color="muted">Having issues?</TextBlock>
          <Link colorScheme="blue" href="mailto:help@concreit.com">
            Contact us
          </Link>
        </HStack>
      </Stack>
    </Container>
  );
};
